import ChangePassword from "./components/user-change-password";
import UserInfo from "./components/user-info";
import NotificationTab from "./components/notification-tab";
import UserCoinTab from "./components/user-coin-tab";
import CabinetStory from "./components/user-cabinet-story";
import TableHistoriesCoin from "./components/table-histories-coin";
import PaymentCandiesTab from "./components/user-payment-candies";

export { ChangePassword, TableHistoriesCoin, UserInfo, UserCoinTab, NotificationTab, CabinetStory, PaymentCandiesTab };
